import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import domainConfig from "./config/domainConfig";

const resources = {
  en: {
    translation: {
      website: "https://glass-railing.com",
      aboutWebsite: "https://glass-railing.com",
      contactWebsite: "https://glass-railing.com/contact",
      firstStep: "First Step",
      secondStep: "Second Step",
      thirdStep: "Third Step",
      chooseProvince: "Choose the Province",
      chooseLanguage: "Language",
      languageEnglish: "English",
      languageFrench: "French",
      chooseTheHeightOfGlass: "Choose the Height of the Glass",
      chooseTheColor: "Choose the color",
      materialTypeSilverLabel: "Stainless",
      materialTypeBlackLabel: "Stainless Black",
      chooseTheSizeOfTheProject: "Choose the Size of the Project",
      small: "Small",
      medium: "Medium",
      large: "Large",
      phone: "Phone",
      phoneNumber: "Phone Number",
      address: "Address",
      name: "Name",
      email: "Email",
      notes: "Notes",
      companyAddress: "67 Westmore Dr Unit 19-20,",
      companyAddress2: "Etobicoke, ON M9V 3Y6",
      companyPhoneNumber: "(647) 740-4552",
      companyEmail: "info@glass-railing.com",
      glass: "Glass",
      pricePerUnit: "Price per Unit",
      quantity: "Quantity",
      zeroQuantityAttachments: "Available Attachments (0 quantity)",
      latestUpdates: "Latest Updates",
      changelog: "Changelog",
      changelogTimeline: "Changelog Timeline",
      dismiss: "Dismiss",
      updatesLauncherAria: "Open latest updates",
      dismissUpdatesAria: "Dismiss updates panel",
      viewFullTimeline: "View Full Timeline",
      backToOnboarding: "Back to Onboarding",
      latestUpdateReleaseDate: "February 25, 2026",
      updateEditableQuantities:
        "Added editable attachment quantities (+/-) in quotation details and step three.",
      update3DSpigotModel:
        "3D: Replaced procedural spigots with the SSC1625N5.glb model.",
      update3DSpigotOrientationAndScale:
        "3D: Rotated spigots to align the clamp gap with glass and increased spigot size by 50%.",
      update3DGlassSeatHeight:
        "3D: Raised glass seating to sit correctly in the spigot clamp slot.",
      update3DDoorPanelFix:
        "3D: Door rendering fixed. R panel remains visible with spigots, doors have no handle and no spigots.",
      quotationNumber: "Quotation Number",
      print: "Print",
      includeConnectors: "Add Connectors",
      removeConnectors: "Remove Connectors",
      contact: "Contact",
      about: "About",
      quotations: "Quotations",
      home: "Home",
      save: "Save",
      login: "Login",
      edit: "Edit",
      delete: "Delete",
      deleteLastLine: "Delete Last",
      clear: "Clear",
      details: "Details",
      instructions: "Instructions",
      instructionsText: "Please fill out the form below, then click Save to save your information.",
      instructionsText2: "If you don't want attachments (glass only), click remove connectors.",
      listOfQuotations: "List of Quotations",
      refresh: "Refresh",
      createdBy: "Created By",
      province: "Province",
      dateCreated: "Date Created",
      noName: "NO NAME",
      chalkLine: "Chalk Line",
      gapSize: "Gap Size",
      note: "Note",
      date: "Date",
      sendToShopify: "Send to Shopify",
      sendToGR: "Send to GR",
      sendToRF: "Send to RF",
      loading: "Loading...",
      length: "Length",
      reverseSide: "Flip Side",
      addTwoDoors: "2 Doors",
      addDoor: "1 Door",
      resetBoard: "Clear All",
      gapWidth: "Gap",
      chalkLineMeasurement: "Custom Gap",
      errorSideTooSmall: "Error: the side is smaller than {{size}}''",
      addedTwoDoors: "Added two doors 🚪!",
      addedOneDoor: "Added one door 🚪!",
      canvasInstructionsTitle: "Instructions:",
      canvasInstruction1: "Draw lines: Use your mouse to draw lines on the canvas. Simply click, hold and drag to draw a line.",
      canvasInstruction2: "Release the mouse button to finish your line.",
      canvasInstruction3: "When ready, scroll down to proceed to Step 3 and continue the process.",
      view3D: "3D View",
      view3DTooltip: "View your design in 3D",
      threeDVisualization: "3D Visualization",
      rotateView: "Rotate: Click and drag",
      zoomView: "Zoom: Scroll wheel",
      panView: "Pan: Right-click and drag",
      resetCamera: "Reset Camera",
      backToDesign: "Back to Design",
      toggleWireframe: "Toggle Wireframe",
      materialPreview: "Material Preview",
      noDesignToVisualize: "No design to visualize. Please create a design first.",
      // Add more English translations here

      // Reseller domain overrides (suffix: _reseller)
      // These will be used when REACT_APP_DOMAIN_MODE=reseller
      website_reseller: "https://your-reseller-domain.com",
      aboutWebsite_reseller: "https://your-reseller-domain.com/about",
      contactWebsite_reseller: "https://your-reseller-domain.com/contact",
      companyAddress_reseller: "Your Reseller Address Line 1",
      companyAddress2_reseller: "Your Reseller Address Line 2",
      companyPhoneNumber_reseller: "(555) 555-5555",
      companyEmail_reseller: "info@your-reseller-domain.com",
      // Add more reseller-specific English translations here
    },
  },
  fr: {
    translation: {
      website: "https://www.cloture-en-verre.com",
      aboutWebsite: "https://cloture-verre.com/guides/bc-transparant",
      contactWebsite: "https://cloture-verre.com/contact",
      firstStep: "Première étape",
      secondStep: "Deuxième étape",
      thirdStep: "Troisième étape",
      chooseProvince: "Choisir la province",
      chooseLanguage: "Langue",
      languageEnglish: "Anglais",
      languageFrench: "Français",
      chooseTheHeightOfGlass: "Choisir la hauteur du la cloture",
      chooseTheColor: "Choisir la couleur",
      materialTypeSilverLabel: "Stainless",
      materialTypeBlackLabel: "Stainless Noir",
      chooseTheSizeOfTheProject: "Choisir la grandeur",
      small: "Petit",
      medium: "Moyen",
      large: "Grand",
      phone: "Téléphone",
      phoneNumber: "Numéro de téléphone",
      address: "Adresse",
      name: "Nom",
      email: "Courriel",
      notes: "Notes",
      companyAddress: "1446 rue Michelin, Laval",
      companyAddress2: "Etobicoke, ON M9V 3Y6,",
      companyPhoneNumber: "(514) 447-0999",
      companyEmail: "info@cloture-verre.com",
      glass: "Verre",
      pricePerUnit: "Prix unitaire",
      quantity: "Quantité",
      zeroQuantityAttachments: "Attaches disponibles (quantité 0)",
      latestUpdates: "Dernières mises à jour",
      changelog: "Mises à jour",
      changelogTimeline: "Chronologie des mises à jour",
      dismiss: "Fermer",
      updatesLauncherAria: "Ouvrir les dernières mises à jour",
      dismissUpdatesAria: "Fermer le panneau des mises à jour",
      viewFullTimeline: "Voir toute la chronologie",
      backToOnboarding: "Retour à l'accueil",
      latestUpdateReleaseDate: "25 février 2026",
      updateEditableQuantities:
        "Ajout des quantités d'attaches modifiables (+/-) dans les soumissions et l'étape trois.",
      update3DSpigotModel:
        "3D : Remplacement des spigots procéduraux par le modèle SSC1625N5.glb.",
      update3DSpigotOrientationAndScale:
        "3D : Rotation des spigots pour aligner la fente avec le verre et augmentation de la taille des spigots de 50 %.",
      update3DGlassSeatHeight:
        "3D : Ajustement de la hauteur du verre pour qu'il s'insère correctement dans la fente du spigot.",
      update3DDoorPanelFix:
        "3D : Correction du rendu des portes. Le panneau R reste visible avec spigots, et les portes n'ont ni poignée ni spigots.",
      quotationNumber: "Soumission",
      print: "Imprimer",
      includeConnectors: "Attaches inclus",
      removeConnectors: "Attaches non inclus",
      contact: "Contactez Nous",
      about: "Notre Histoire",
      quotations: "Soumissions",
      home: "Accueil",
      save: "Sauvegarder",
      login: "Connexion",
      edit: "Modifier",
      delete: "Supprimer",
      deleteLastLine: "Supprimer la dernière",
      clear: "Effacer",
      details: "Détails",
      instructions: "Instructions",
      instructionsText: "Veuillez remplir le formulaire ci-dessous, puis cliquez sur Sauvegarder pour enregistrer vos informations.",
      instructionsText2: "Si vous ne souhaitez pas d'attaches (seulement du verre), cliquez sur attaches non inclus.",
      listOfQuotations: "Liste des soumissions",
      refresh: "Rafraîchir",
      createdBy: "Créé par",
      province: "Province",
      dateCreated: "Date de création",
      noName: "AUCUN NOM",
      chalkLine: "Ligne de craie",
      gapSize: "Taille de l'espace",
      note: "Note",
      date: "Date",
      sendToShopify: "Envoyer à Shopify",
      sendToGR: "Envoyer à GR",
      sendToRF: "Envoyer à RF",
      loading: "Chargement...",
      length: "Longueur",
      reverseSide: "Inverser côté",
      addTwoDoors: "2 portes",
      addDoor: "1 porte",
      resetBoard: "Tout effacer",
      gapWidth: "Écart",
      chalkLineMeasurement: "Écart personnalisé",
      errorSideTooSmall: "Erreur : le côté est plus petit que {{size}} pouces",
      addedTwoDoors: "Ajouté deux portes 🚪!",
      addedOneDoor: "Ajouté une porte 🚪!",
      canvasInstructionsTitle: "Instructions",
      canvasInstruction1: "Tracer des lignes : Utilisez votre souris pour tracer des lignes sur la toile. Il suffit de cliquer, maintenir et glisser pour dessiner une ligne.",
      canvasInstruction2: "Relâchez le bouton de la souris pour terminer votre ligne.",
      canvasInstruction3: "Lorsque vous êtes prêt, faites défiler vers le bas pour passer à l'Étape 3 et continuer le processus.",
      view3D: "Vue 3D",
      view3DTooltip: "Voir votre conception en 3D",
      threeDVisualization: "Visualisation 3D",
      rotateView: "Rotation : Cliquez et glissez",
      zoomView: "Zoom : Molette de la souris",
      panView: "Panoramique : Clic droit et glissez",
      resetCamera: "Réinitialiser la caméra",
      backToDesign: "Retour à la conception",
      toggleWireframe: "Basculer le fil de fer",
      materialPreview: "Aperçu du matériau",
      noDesignToVisualize: "Aucune conception à visualiser. Veuillez d'abord créer une conception.",
      // Add more French translations here

      // Reseller domain overrides (suffix: _reseller)
      // These will be used when REACT_APP_DOMAIN_MODE=reseller
      website_reseller: "https://votre-domaine-revendeur.com",
      aboutWebsite_reseller: "https://votre-domaine-revendeur.com/a-propos",
      contactWebsite_reseller: "https://votre-domaine-revendeur.com/contact",
      companyAddress_reseller: "Adresse du revendeur ligne 1",
      companyAddress2_reseller: "Adresse du revendeur ligne 2",
      companyPhoneNumber_reseller: "(555) 555-5555",
      companyEmail_reseller: "info@votre-domaine-revendeur.com",
      // Add more reseller-specific French translations here
    },
  },
};

/**
 * Helper to get translation with domain fallback
 * Use this for keys that have domain-specific versions
 *
 * Example:
 *   t(getDomainKey("companyEmail")) // returns "info@cloture-verre.com" or reseller email
 */
export const getDomainKey = (key) => {
  if (domainConfig.isReseller) {
    return `${key}_reseller`;
  }
  return key;
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("lang") || domainConfig.defaultLanguage,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
